export default defineNuxtPlugin(async (_nuxtApp) => {
  if (globalConfig().faqs.length < 1) {
    globalConfig().setFaqs(await useGetFAQs());
  }
});
